//import axios from 'axios';
let kv = 
{
    hello: function()
    {
        console.log("Hello: sy.kv");
    },
    get: function( k )
    {
		return localStorage.getItem( k );
    },
    set: function( k, v )
    {
		localStorage.setItem( k, v );
    },
	del: function( k )
    {
		localStorage.removeItem( k );
    },
	clear: function()
    {
		localStorage.clear();
    }
};

export default kv;